const Landing = {
    content: null,
    nav: null,
    init: () => {
        Landing.content = document.querySelector("#landing");
        Landing.main = document.querySelector("#main");
        Landing.nav = document.querySelector("#nav");
        Landing.bind();
    },
    bind: (e) => {
        if (Landing.content) {
            Landing.content.addEventListener("click", (e) => {
                if (!Landing.content.classList.contains("active")) {
                    Landing.content.classList.add("active");
                } else {
                    Landing.content.classList.remove("active");
                }
            });
            document.addEventListener("mousemove", Landing.move);
        }
        if (Landing.nav) {
            Landing.nav.addEventListener("click", (e) => {
                if (!Landing.nav.classList.contains("active")) {
                    Landing.nav.classList.add("active");
                    Landing.main.style.overflow = "hidden";
                } else {
                    Landing.nav.classList.remove("active");
                    Landing.main.style.overflow = "auto";
                }
            });
            document.addEventListener("mousemove", Landing.move);
        }
    },
    move: (e) => {
        let height = document.body.clientHeight;
        let width = document.body.clientWidth;
        let mouseXpercentage = Math.round((e.pageX / width) * 400);
        let mouseYpercentage = Math.round((e.pageY / height) * width);
        const gradient = document.querySelectorAll(".radial-gradient");
        gradient.forEach(function(item, index) {
            item.style.backgroundImage = 'linear-gradient(' + mouseXpercentage + 'deg , rgb(80,80,80,.8), rgb(10,10,10))';
        })
    }
}
export default Landing;